import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheHeader } from '../../../components/ArcheHeader';
import { StorageBrowsePage } from '../../shared/storage';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import type { StorageArcheConfig } from '../../shared/storage';

const config: StorageArcheConfig = {
  title: 'Litcraft Addressables',
  domainAdminRole: 'litcraft_admin',
  accessDeniedMessage:
    'You need admin or litcraft_admin permissions to access Litcraft Addressables.',
  queryKeyNamespace: queryKeys.litcraftAddressables.all,
  api: api.litcraftAddressablesStorage,
  acceptedFileTypes: '.bundle,.json,.hash,image/*',
};

export function LitcraftAddressablesArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <ArcheHeader archeId="arche_litcraft_addressables" title="Litcraft Addressables" />
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route path="/*" element={<StorageBrowsePage config={config} />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
